<template>
  <div id="app">
    <v-container class="mt-3">
      <Header />
      <BookEventSlot
        :eventData="event"
        v-if="view == 'slot' && status === 'EXISTS'"
      />
      <BookEventWorkshop
        :eventData="event"
        v-if="view == 'workshop' && status === 'EXISTS'"
      />
      <BookEventRegisterInterest
        :eventData="event"
        v-if="view == 'register' && status === 'EXISTS'"
      />
      <BookEventHealthScreeningSlot
        :eventData="event"
        v-if="view == 'healthscreening' && status === 'EXISTS'"
      />
      <BookEventVirusTesting
        :eventData="event"
        v-if="view == 'virustesting' && status === 'EXISTS'"
      />

      <v-alert
        border="top"
        class="mt-2"
        colored-border
        type="info"
        elevation="2"
        v-if="status == 'NOT AVAILABLE'"
      >
        {{ availabilityMessage }}
      </v-alert>

      <v-card class="mx-auto" max-width="400" v-if="status === false">
        <v-toolbar flat center>
          <v-spacer />
          <v-toolbar-title class="display-1">Oooooooops...</v-toolbar-title>
          <v-spacer />
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text>
          <div class="subtitle-1 black--text text-center mb-2">
            We can't find this code, please try again
          </div>
          <v-text-field
            label="Your Event Code"
            v-model="resubmitCode"
            @keydown.enter="reSubmitEventCode"
            outlined
          ></v-text-field>
          <v-btn
            depressed
            large
            block
            class="managebookingsbutton hp--btn"
            @click="reSubmitEventCode"
            >Submit</v-btn
          >
        </v-card-text>
      </v-card>
      <Footer />
    </v-container>
  </div>
</template>

<script>
import { Booking } from "../classes/Booking";
import BookEventSlot from "../components/BookEventSlot";
import BookEventWorkshop from "../components/BookEventWorkshop";
import BookEventRegisterInterest from "../components/BookEventRegisterInterest";
import BookEventHealthScreeningSlot from "../components/BookEventHealthScreeningSlot";
import BookEventVirusTesting from "../components/BookEventVirusTesting";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default {
  components: {
    BookEventSlot,
    BookEventWorkshop,
    BookEventRegisterInterest,
    BookEventHealthScreeningSlot,
    BookEventVirusTesting,
    Footer,
    Header
  },
  data() {
    return {
      event: null,
      view: false,
      status: null, // EXISTS, NULL, EXPIRED
      resubmitCode: null,
      availabilityMessage: null
    };
  },
  async created() {
    this.event = await Booking.getEvent(
      this.$route.params.eventcode.toLowerCase()
    );

    // Show Event?
    if (this.event) {
      const available = await Booking.checkAvailability(this.event[0]);
      if (available === true) {
        this.status = "EXISTS";
      } else {
        this.availabilityMessage = available;
        this.status = "NOT AVAILABLE";
      }

      this.view = this.event[0].type;
    } else {
      this.status = false;
    }
  },
  methods: {
    reSubmitEventCode() {
      window.location = "/booking/" + this.resubmitCode.toLowerCase();
      this.$router
        .replace({
          name: "bookevent",
          params: { eventcode: this.resubmitCode.toLowerCase() }
        })
        .catch(() => {});
    }
  }
};
</script>
